@if (showPevButton()) {
  <button (click)="backToPreviousCategory()" class="header-btn p-absolut">
    <ui-icon faName="chevron-left" faStyle="light"></ui-icon>
    Zurück
  </button>
}

<div [ngClass]="currentCategoryClass()" role="menu">
  @if (!isRootCategory()) {
    <ui-toggle-navigation-item
      mode="link"
      [item]="currentItem()"
      [title]="currentCategoryAllItemsLinkTitle()"
      [chevron]="showItemChevron()"
      [ngClass]="navigationItemClass()"
      [class.highlighted]="true"
      (click)="selectNavItem(currentItem(), 'link')"
    ></ui-toggle-navigation-item>
  }

  @for (item of currentItem().children; track item) {
    @let mode = item.children?.length ? 'button' : 'link';
    <ui-toggle-navigation-item
      [mode]="mode"
      [item]="item"
      [chevron]="showItemChevron()"
      [ngClass]="navigationItemClass()"
      (click)="selectNavItem(item, mode)"
    ></ui-toggle-navigation-item>
  }
</div>

@if (showBackToMainButton()) {
  <button (click)="backToMainCategory()" class="back-btn">
    <ui-icon faName="chevron-left" faStyle="light"></ui-icon>
    Zurück zur Sortimentsübersicht
  </button>
}
